// DS: i3.12
import React from 'react';
import IconWrap, { Props } from '../../IconWrap';

const GiveBadge: React.FC<Props> = props => {
  return (
    <IconWrap {...props}>
      <svg
        width="0"
        height="0"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M18.195 3a1 1 0 01.894.553l2.432 4.862a1 1 0 01-.127 1.087l-.403.484a.917.917 0 01-1.292.117l-.061-.056-.146-.146a.874.874 0 01-.124-1.079l.071-.098L17.576 5H6.05L4.186 8.724l7.627 9.151.044-.053a.917.917 0 011.292-.117l.061.056.064.064a1 1 0 01.062 1.348l-.755.905a1 1 0 01-1.536 0L2.232 9.502a1 1 0 01-.126-1.087l2.43-4.862A1 1 0 015.432 3h12.764zm-1.382 7a1 1 0 011 1v2h2a1 1 0 110 2h-2v2a1 1 0 11-2 0v-2h-2a1 1 0 010-2h2v-2a1 1 0 011-1z"></path>
      </svg>
    </IconWrap>
  );
};
GiveBadge.displayName = 'GiveBadge';

export default GiveBadge;
